/**
 * Chemin de l'ecran « Demandes RGPD ».
 *
 * Module **pur**, importe par l'ecran, `App.tsx` et le registre de navigation
 * (`src/ui/navigation.ts`) : l'ecrire en clair aux trois endroits ferait
 * diverger le menu de la route sans qu'aucun test ne tombe.
 */
export const PRIVACY_REQUESTS_PATH = '/compliance/privacy-requests';
